import Vue from "vue";
import Vuex from 'vuex'

Vue.use(Vuex);




export default new Vuex.Store({
  state: {
    isWhite: false,//导航背景色
    isDeveloper: 2,
    skillName:'', //技能名称
    skillState:'', //技能状态
    clientName:'', //硬件名称
    clientState:'', //硬件状态
    toActive: '1', //
    where: 'home',//登录之前在哪个页面默认首页，另两个是product和skill
    skillSetting: 'all', //记录用户之前所在的技能选项卡，默认all所有技能，另一个是added,已添加技能
    messageNum:0 ,    //记录消息数量，默认为0
    switchRoute: true,
    page: 1,
    obj: {}
  },
  mutations: {
    changedeviceid (state, obj) {
      state.obj = obj
    },
    changeRoute (state, flag) {//没保存,是否为可跳转
      state.switchRoute = flag
    },
    changeFalse(state) {
      state.isWhite = false;
    },//改变导航背景色
    changeTrue(state) {
      state.isWhite = true;
    },//改变导航背景色
    changeActive(state, a) {
      state.toActive = a;
    },
    changeWhere(state, e) {
      state.where = e;
    }, //记录用户登录之前的页面
    changeSkillSetting(state, {e, page}) {
      state.skillSetting = e;
      state.page = page;
    }, //记录用户之前所在的技能选项卡
    changeIsDeveloper(state, e) {
      state.isDeveloper = e;
    }, //记录用户之前所在的技能选项卡
    changeMessageNum(state, e) {
      state.messageNum = e;
    }, //记录消息数量
    changeSkillName(state, e) {
      state.skillName = e;
    }, //技能名称
    changeSkillState(state, e) {
      state.skillState = e;
    }, //技能状态
    changeClientName(state, e) {
      state.clientName = e;
    }, //硬件名称
    changeClientState(state, e) {
      state.clientState = e;
    }, //硬件状态
  },
  actions: {
    changeF(context) {
      context.commit('changeFalse')
    },
    changeT(context) {
      context.commit('changeTrue')
    },
    changeA(context, a) {
      context.commit("changeActive", a)
    },
    changeWhere(context, e) {
      context.commit("changeWhere", e)
    },
    changeSkillSetting(context, e) {
      context.commit("changeSkillSetting", e)
    },
    changeIsDeveloper(context, e) {
      context.commit("changeIsDeveloper", e);
    },
    changeMessageNum(context, e) {
      context.commit("changeMessageNum", e);
    },
    changeSkillName(context, e) {
      context.commit("changeSkillName", e);
    },
    changeSkillState(context, e) {
      context.commit("changeSkillState", e);
    },
    changeClientName(context, e) {
      context.commit("changeClientName", e);
    },
    changeClientState(context, e) {
      context.commit("changeClientState", e);
    },
    changeR(context, flag) {
      context.commit('changeRoute', flag)
    },
    changedevId(context, obj) { // 保存deviceid
      context.commit('changedeviceid', obj)
    },
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js